import { TextField } from '@mui/material';
import { RegisterServiceFields } from 'TenantModule/hooks/useTenantRegisterServiceForm';
import { MaskedInput } from 'components/MaskedInput';
import { FC } from 'react';

export const DbCredentialFields: FC<{
  onRegisterServiceFormChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  registerTenantServiceParams: RegisterServiceFields;
  disabledFields: boolean;
  /**
   * galaxy-server accepts the credentials only as a complete set (all five or
   * none), so the caller flips this on as soon as any one field is filled.
   */
  required?: boolean;
}> = ({
  registerTenantServiceParams,
  onRegisterServiceFormChange,
  disabledFields,
  required = false,
}) => {
  return (
    <>
      <TextField
        label="DB Host"
        name="dbHost"
        type="text"
        value={registerTenantServiceParams.dbHost}
        onChange={onRegisterServiceFormChange}
        disabled={disabledFields}
        required={required}
        variant="outlined"
      />
      <TextField
        label="DB Name"
        name="dbName"
        type="text"
        value={registerTenantServiceParams.dbName}
        onChange={onRegisterServiceFormChange}
        disabled={disabledFields}
        required={required}
        variant="outlined"
      />
      <MaskedInput
        label="DB Password"
        name="dbPassword"
        value={registerTenantServiceParams.dbPassword}
        onChange={onRegisterServiceFormChange}
        disabled={disabledFields}
        required={required}
        variant="outlined"
      />
      <TextField
        label="DB User"
        name="dbUser"
        type="text"
        value={registerTenantServiceParams.dbUser}
        onChange={onRegisterServiceFormChange}
        disabled={disabledFields}
        required={required}
        variant="outlined"
      />
      <TextField
        label="DB Host Ro"
        name="roHost"
        type="text"
        value={registerTenantServiceParams.roHost}
        onChange={onRegisterServiceFormChange}
        disabled={disabledFields}
        required={required}
        variant="outlined"
      />
    </>
  );
};
